const TEXT_RULES = {
  thumb: {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: false,
    tagline: false,
    thumb: false,
  }
};

if (__ALL__ || __WSJ__) {
  TEXT_RULES.E = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES.D = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES.G = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES.top = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES.soc = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES.tab = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES.fon = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['4u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['8u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['12u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['16u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['appfeed'] = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['video'] = {
    title: true,
    dek: true,
    subdek: false,
    note: false,
    source: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['preview'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
}

if (__ALL__ || __BARRONS__) {
  TEXT_RULES['barrons-4col-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: false,
    source: false,
    date: false,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['barrons-8col-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['barrons-10col-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  },
  TEXT_RULES['barrons-fullscreen-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  };
  TEXT_RULES['b4u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  };
  TEXT_RULES['barrons-8col-inset'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  };
  TEXT_RULES['barrons-10col-inset'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  },
  TEXT_RULES['barrons-fullscreen-inset'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  },
  TEXT_RULES['print-barrons'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
}

if (__ALL__ || __FINANCIALNEWS__) {
  TEXT_RULES['fn-small-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: false,
    source: false,
    date: false,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['fn-medium-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
  };
  TEXT_RULES['fn-large-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  };
  TEXT_RULES['fn4u'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  };
  TEXT_RULES['fn-medium-inset'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  };
  TEXT_RULES['fn-large-inset'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false,
  };
  TEXT_RULES['print-fn'] = {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: false,
    tagline: false,
    thumb: false,
  };
}

if (__MARKETWATCH__) {
  TEXT_RULES['marketwatch-ZT'] = {
    title: false,
    dek: false,
    subdek: false,
    legend: false,
    note: false,
    source: false,
    date: false,
    tagline: false
  };
  TEXT_RULES['marketwatch-ZR'] = {
    title: false,
    dek: false,
    subdek: false,
    legend: false,
    note: false,
    source: false,
    date: false,
    tagline: false
  };
}

export function getBestRule(id) {
  // If a rule for @param id is found, return it.
  if (TEXT_RULES[id] !== undefined) {
    return TEXT_RULES[id];
  }
  // If a rules that begins with @param id is found, return it. This is useful
  // for example with any id that starts with "thumb".
  for (let i = 0, keys = Object.keys(TEXT_RULES); i < keys.length; i++) {
    let key = keys[i];
    if (id.indexOf(key) === 0) {
      return TEXT_RULES[key];
    }
  }
  // Default:
  return {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: 'right'
  };
}


export default TEXT_RULES;



// WEBPACK FOOTER //
// ./src/chart/outer/text-rules.js